import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { PropertyCreateRequestBody, PropertyCreateResponse } from "./types";

export class PropertyCreateAPI extends BaseAPI<
  PropertyCreateRequestBody,
  PropertyCreateResponse
> {
  protected route = ApiRoutes.property.create;
  protected method = RequestMethod.POST;
  protected hasFile = true;

  protected prepareRequest(data: FormData): RequestInit {
    return {
      method: this.method,
      body: data,
    };
  }
}
